<template>
  <mdb-row class="my-5">
    <mdb-col md="6" class="mx-auto">
      <mdb-card>
        <mdb-card-body>
          <mdb-card-title v-if="editmode"><mdb-icon icon="user-edit"/> 회원 정보 수정</mdb-card-title>
          <mdb-card-title v-else @change-profile="onChangeProfile"><mdb-icon icon="user-cog"/> 회원 정보</mdb-card-title>
          <mdb-card-text>
            <profileEdit v-if="editmode" :user="user" @mode-change="onModeChange" @change-profile="onChangeProfile"/>
            <profile v-else :user="user" @mode-change="onModeChange"/>
          </mdb-card-text>
        </mdb-card-body>
      </mdb-card>
    </mdb-col>
  </mdb-row>
</template>
<script>
import { mdbInput, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbCardTitle, mdbCardText, mdbIcon } from 'mdbvue';
import profile from '@/components/auth/Profile'
import profileEdit from '@/components/auth/ProfileEdit'
import authService from '@/service/auth'
export default {
  name: 'Profile',
  components: { profile, profileEdit, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbCardTitle, mdbCardText, mdbIcon },
  data: () => ({
    user: {},
    editmode: false
  }),
  methods: {
    async onChangeProfile () {
      const { name, gender, email, address } = this.user;
      await authService.updateProfile({ name, gender, email, address });
      this.editmode = false;
    },
    onModeChange (value) {
      this.editmode = value;
    }
  },
  async created () {
    this.user = await authService.getProfile();
  }
}
</script>
